// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#fireLightMainDiv .navigationButtonsContainer {\n  display: none !important;\n}\n\n#fireLightMainDiv .ITWizardRoot {\n  width: auto;\n}\n\n#fireLightMainDiv .ITComponent > div {\n  height: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
